import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { styled, useTheme } from '@mui/material';
import logo from 'src/assets/images/logos/logo.png';
import faviconLogo from 'src/assets/images/logos/faviconLogo.png'
const Logo = () => {
  const theme = useTheme();
  const customizer = useSelector((state) => state.customizer);
  
  const LinkStyled = styled(Link)(() => ({
    height: customizer?.isCollapse&& !customizer?.isSidebarHover ?'50px' :'55px',
    width: customizer.isCollapse && !customizer?.isSidebarHover ? '50px' : '180px',
    overflow: 'hidden',
    display: 'block',
    marginLeft: customizer.isCollapse && '-6px'
  }));

  return (
    <LinkStyled to="/" style={{
      display: 'flex',
      alignItems: 'center',
    }}>
      <img 
        src={logo} 
        alt="Logo" 
        style={{ 
          height: '100%', 
          width: 'auto',
          mb: customizer?.isCollapse&& 20,
          filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none'
        }} 
      />
    </LinkStyled>
  );
};

export default Logo;